import Header from "../../../../layouts/header/Header";
import Footer from "../../../../layouts/footer/Footer";
import HeadingComponent from "../HeadingComponent";
const RefundAndCancelation = () => {
  return (
    <>
      <Header />
      <HeadingComponent
        heading="REFUND AND CANCELLATION POLICY"
        subheading="Last updated on September, 2022"
      />

      <div className="px-customPaddingMobile lg:pl-customPadding lg:pr-0   max-w-[733px] 2xl:px-0 2xl:w-[1340px] 2xl:mx-auto">
        <div className="mb-[50px] lg:mb-[70px]">
          <h2 className="mb-2 lg:mb-8 font-openSans font-normal text-mobile-body-lg lg:text-web-h3 leading-[22px] lg:leading-[30px] text-brand-bgBlack">
            Refund Request
          </h2>
          <div className="font-openSans font-normal text-mobile-body-sm lg:text-web-body-lg leading-5 text-brand-textGrey">
            Our Website does not entertain any refund requests. Once a payment
            has been made by a User, and they choose not to participate for
            whatever reason, no amount of the payment will be refunded. All
            payments are made via payment gateways, Users are advised to read
            all information carefully before making a payment. We will not be
            held liable for any payment discrepancies.
          </div>
        </div>
        <div className="mb-[50px] lg:mb-[70px]">
          <h2 className="mb-2 lg:mb-8 font-openSans  text-mobile-body-lg lg:text-web-h3 leading-[22px] lg:leading-[30px] text-brand-bgBlack">
            Cancellation Request
          </h2>
          <div className="font-openSans font-normal text-mobile-body-sm lg:text-web-body-lg leading-5 text-brand-textGrey">
            Our Website does not entertain any cancellation requests. Users can
            choose not to participate but we do not have any provision for
            cancellation of a participant. We maintain a negative list of all
            fraudulent transactions and non-complying users and reserve the
            right to deny access to such users at any time or cancel any orders
            placed by them in future.
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default RefundAndCancelation;
